// extracted by mini-css-extract-plugin
module.exports = {"subtitleIcon":"styles_subtitleIcon__3Pkwq","toggleContainer":"styles_toggleContainer__1_SZ4"};